import chatNotifSound from '../../assets/audio/chat-notif.wav';

export const playChatNotificationSound = () => {
    try {
        const audio = new Audio(chatNotifSound);
        audio.play().catch(error => {
            console.error('Error playing chat notification sound:', error);
        });
    } catch (error) {
        console.error('Error creating audio for chat notification:', error);
    }
};

export const playGeneralNotificationSound = () => {
    // If you have general-notif.wav, import it here
    // For now, we'll use chat sound as fallback
    playChatNotificationSound();
};
